module.exports = __webpack_public_path__ + "img/game-of-sultans.18b6d37.png";